import Stack from '@zenbusiness/zui/Stack';
import { superstyled } from '@zenbusiness/zui/styles';

export const WidgetAreaStack = superstyled({
  tag: Stack,
  name: 'WidgetArea',
  slot: 'WidgetAreaStack',
  styles: ({ theme }) => ({
    gap: '1rem',

    [theme.breakpoints.up('sm')]: {
      gap: '1.5rem',
    },
  }),
});
